import ManageFileAccess from './ManageFileAccess.component';

export default ManageFileAccess;